import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

// material-ui
import { Box, Collapse, List, Typography } from '@mui/material';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

// project import
import NavItem from './NavItem';

// ==============================|| NAVIGATION - LIST GROUP ||============================== //

const NavGroup = ({ item }) => {
  const { drawerOpen, appUser } = useSelector((state) => state.appreducer);
  const [collapseOpen, setCollapseOpen] = useState(false);
  const { pathname } = useLocation();
  const isAdmin = (appUser.user_type === 'ORG_ADMIN' || appUser.user_type === 'SUPER_ADMIN') ? true : false;

  // console.log('isAdmin', isAdmin);


  const handleCollapseClick = (inputItem) => {
    if (inputItem.type === 'collapse') {
      setCollapseOpen(!collapseOpen);
    }
    if (inputItem.type === 'item') {
      setCollapseOpen(false);
    }
  };
   // active menu item on page load
   useEffect(() => {
    if (pathname.includes('/settings')) {
      setCollapseOpen(true);
    }
    // eslint-disable-next-line
  }, [pathname]);

  const navCollapse = item.children?.map((menuItem, index) => {
    if (index === 0 && !isAdmin) {
      return null;
  }
  
  // For other menu items, render based on admin status
  if (menuItem.adminOnly && !isAdmin) {
      return null;
  }
    switch (menuItem.type) {
      case 'collapse':
        return (
          <div key={`${menuItem.id}-div`}>
            <NavItem
              key={menuItem.id}
              item={menuItem}
              level={1}
              collapseOpen={collapseOpen}
              onCollapsClick={handleCollapseClick}
              endIcon={collapseOpen ? <ExpandLess /> : <ExpandMore />}
            />
            <Collapse key={'collapse'} in={collapseOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {menuItem.children?.map((item1) => {
                  return <NavItem key={item1.id} item={item1} level={2} />;
                })}
              </List>
            </Collapse>
          </div>
        );
      case 'item':
      case 'collapseItem':
        return <NavItem key={menuItem.id} item={menuItem} level={1} onCollapsClick={handleCollapseClick} />;
      default:
        return (
          <Typography key={menuItem.id} variant="h6" color="error" align="center">
            Fix - Group Collapse or Items
          </Typography>
        );
    }
  });

  return (
    <List
      subheader={
        item.title &&
        drawerOpen && (
          <Box sx={{ pl: 3, mb: 1.5 }}>
            <Typography variant="subtitle2" color="textSecondary">
              {item.title}
            </Typography>
            {/* only available in paid version */}
          </Box>
        )
      }
      sx={{ mb: drawerOpen ? 1.5 : 0, py: 0, zIndex: 0 }}
    >
      {navCollapse}
    </List>
  );
};

NavGroup.propTypes = {
  item: PropTypes.object
};

export default NavGroup;
